import React from 'react';
import styled from 'styled-components';

import { CtaButton } from '../styled';

const Inner = styled.div`
  max-width: 990px;
  margin: 0 auto;
  padding-bottom: 80px;
`;

const CtaContainer = styled.div`
  margin-top: 88px;
  padding: 28px 40px;
  border: solid 1px #f5f5f5;
  border-radius: 12px;

  @media (min-width: 768px) {
    display: flex;
    justify-content: space-between;
    text-align: left;
  }
`;

const CtaLabel = styled.div`
  font-size: 20px;
  font-weight: 700;
  letter-spacing; 0.6px;
  line-height: 21px;
`;

const CtaDesc = styled.div`
  color: #999999;
  font-size: 18px;
  font-weight: 300;
  letter-spacing; 0.45px;
  line-height: 21px;
  padding-top: 4px;
`;

const ContactButton = styled(CtaButton)`
  background: rgba(30, 92, 179, 0.2);
  color: #1e5cb3;
  width: 180px;
  margin-top: 20px;

  &:hover {
    background: rgba(63, 129, 223, 0.2);
  }

  &:active {
    background: rgba(19, 58, 113, 0.2);
  }

  @media (min-width: 768px) {
    margin-top: 0;
  }
`;

function PartnerEmailCapture({ input }) {
  return (
    <div>
      <Inner>
        <CtaContainer>
          <div>
            <CtaLabel>{input.primary.headline.text}</CtaLabel>
            <CtaDesc>{input.primary.description.text}</CtaDesc>
          </div>
          <div>
            <a href="mailto: support@trueusd.com">
              <ContactButton>{input.primary.cta_button_label.text}</ContactButton>
            </a>
          </div>
        </CtaContainer>
      </Inner>
    </div>
  );
}

export { PartnerEmailCapture };
